import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Typography(theme: Theme): Components<Theme> {
  return {
    MuiTypography: {
      styleOverrides: {
        // MUI v9 removed the `paragraph` prop. Do not apply paragraph spacing to
        // every <p> (body1/body2 default to <p>) — that breaks dense layouts.
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}
